module.exports = __webpack_public_path__ + "static/media/dayna.b45bc42c.jpg";